<google-map
  #map
  [options]="googleMapOptions"
  [zoom]="zoom"
  [attr.center]="center"
  (mapClick)="onMapClick($event)"
  height="100%"
  width="100%">
</google-map>
